export default "__VITE_ASSET__c51aae9a__"